const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const OfficeModal = require("./OfficeModal");
const Checkbox = require("../../core/view/Checkbox");
const {ErrorIcon} = require("../../core/view/ErrorIcon");
const LoadingCircle = require("../../core/view/LoadingCircle");
const Analytics = require("../../core/util/Analytics");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const StringUtil = require("../../../shared/StringUtil");
const AT = require("../../core/vault/ActionTypes");
const CopyTable = require("../data/CopyTable");
const roles = CopyTable.getMailingListRoles();
const Copy = CopyTable.getEmailModalCopy();

const styles = require("./styles/EmailModal.css");
const MIN_WAIT_TIME = 2000;

//Initial Steps: enterEmail, pickRole, signingUp,
//After Completion: signUpSuccess, signUpFail, duplicateEmail (special fail)

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "EmailModal",

		propTypes: {
			startOpen: PT.bool,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		// Used by vault update HOC
		vaultEvents: {
			beginEmailSignUp: function(email) {
				const isEmailValid = StringUtil.isValidEmail(email);
				this.setState({
					isOpen: true,
					step: isEmailValid ? "pickRole" : "enterEmail",
					email: email,
					emailInvalid: !isEmailValid && !!email,
					role: null,
					roleInvalid: false,
					agree: false,
					agreeError: false,
					startedSignUp: null,
				});
			},
			emailSignUpStarted: function() {
				this.setState({step: "signingUp"});
			},
			emailSignUpComplete: function(nextStep) {
				const timeElapsed = Date.now() - this.state.startedSignUp;
				const newState = {step: nextStep, isOpen: true};
				if (timeElapsed < MIN_WAIT_TIME) {
					setTimeout(
						() => this.setState(newState),
						MIN_WAIT_TIME - timeElapsed
					);
				} else {
					this.setState(newState);
				}
			},
			emailSignUpEnd: function() {
				this.setState({isOpen: false});
			},
		},

		getInitialState: function() {
			return {
				isOpen: this.props.startOpen || false,
				step: "enterEmail",
				email: "",
				emailInvalid: false,
				role: null,
				roleInvalid: false,
				agree: false,
				agreeError: false,
				startedSignUp: null,
			};
		},

		//If someone goes straight to the mailing list page (currently /mailingList), the page starts
		//with this modal open and they're able to type while the js hasn't started yet (so the email
		//isn't going into the state). We need to use the input ref to see if they've typed anything that should
		//be part of the email.
		componentDidMount: function() {
			if (this.emailInput && this.emailInput.value && !this.state.email) {
				// eslint-disable-next-line react/no-did-mount-set-state
				this.setState({email: this.emailInput.value});
			}
		},

		onClose: function() {
			this.setState({isOpen: false});
		},

		onContinue: function() {
			const {step, role, email, agree} = this.state;
			if (step === "enterEmail") {
				if (StringUtil.isValidEmail(email)) {
					this.setState({step: "pickRole"});
				} else {
					this.setState({emailInvalid: true});
				}
			} else if (step === "pickRole") {
				if (!role) {
					this.setState({roleInvalid: true});
				} else if (!agree) {
					this.setState({agreeError: true});
				} else {
					this.onSignUp();
				}
			} else if (step === "signUpFail") {
				this.onSignUp();
			} else if (step === "signUpSuccess" || step === "duplicateEmail") {
				this.onClose();
			}
		},

		onSignUp: function() {
			this.props.dispatch({
				type: AT.EMAIL_SIGN_UP_REQUEST,
				email: this.state.email,
				role: this.state.role,
			});
			this.setState({startedSignUp: Date.now()});
		},

		handleKeyPress: function(evt) {
			if (evt.which === 13) {
				this.onContinue();
			}
		},

		handleChange: function(evt) {
			this.setState({email: evt.target.value, emailInvalid: false});
		},

		handlePickRole: function(r) {
			if (this.state.role === r) {
				this.setState({role: null});
			} else {
				this.setState({role: r, roleInvalid: false});
			}
		},

		setAgree: function(newAgree) {
			this.setState({
				agree: newAgree,
				agreeError: false,
			});
		},

		renderRoleChoices: function() {
			const roleOptions = roles.map((r, i) => {
				const isSelected = r === this.state.role;
				const onClick = () => this.handlePickRole(r);
				let overallClass = styles.role;
				overallClass += isSelected ? " " + styles.selected : "";
				return (
					<div className={styles.roleContainer} key={"role-" + i}>
						<div className={overallClass} onClick={onClick}>
							<div className={styles.circle} />
							{r}
						</div>
					</div>
				);
			});
			return <div className={styles.roles}>{roleOptions}</div>;
		},

		renderEmailInput: function(step, email, emailInvalid) {
			const inputStyle =
				styles.input + (emailInvalid ? " " + styles.invalid : "");
			const invalidMessage = !this.state.email
				? Copy.emailMissing
				: Copy.emailInvalid;
			return (
				<div className={styles.inputContainer}>
					<input
						className={inputStyle}
						type="text"
						placeholder={"Email"}
						value={email}
						onChange={this.handleChange}
						onKeyPress={this.handleKeyPress}
						autoComplete={"section-emailModal"}
						ref={e => (this.emailInput = e)}
						{...Analytics.getHotjarSuppressionAttributes()}
					/>
					{Copy.privacyPolicy}
					<div
						className={emailInvalid ? styles.errorVisible : styles.errorHidden}
					>
						{invalidMessage}
					</div>
				</div>
			);
		},

		render: function() {
			const {
				step,
				email,
				emailInvalid,
				roleInvalid,
				agreeError,
				agree,
				isOpen,
			} = this.state;
			//Decide the main contents of the step
			let contents,
				aboveTitle,
				belowContents = null;
			if (step === "enterEmail") {
				contents = this.renderEmailInput(step, email, emailInvalid);
			} else if (step === "pickRole") {
				//roleAndCheck, agreeCheck
				contents = (
					<div className={styles.roleAndCheck}>
						{this.renderRoleChoices()}
						<Checkbox
							className={styles.agreeCheck}
							text={Copy.agreement}
							onClick={() => this.setAgree(!agree)}
							isSelected={agree}
						/>
					</div>
				);
				const errorClass =
					roleInvalid || agreeError ? styles.roleError : styles.roleErrorHidden;
				const errorText = roleInvalid
					? Copy.roleNotChosen
					: Copy.agreeNotChecked;
				belowContents = <div className={errorClass}>{errorText}</div>;
			} else if (step === "signingUp") {
				contents = (
					<div className={styles.loading}>
						<LoadingCircle colorType="color" />{" "}
					</div>
				);
			} else if (step === "signUpSuccess") {
				contents = (
					<div className={styles.stretch}>
						<div className={styles.imgContainer}>
							<img
								className={styles.happyImg}
								alt="BA Headmaster on Computer"
								src={
									global.BASE_URL +
									"assets/images/office/characters/headmaster-computer.svg"
								}
							/>
						</div>
					</div>
				);
			} else if (step === "signUpFail") {
				aboveTitle = <ErrorIcon className={styles.failIcon} />;
			} else if (step === "duplicateEmail") {
				aboveTitle = (
					<img
						className={styles.warningIcon}
						alt=""
						src={
							global.BASE_URL + "assets/images/office/elements/warning-icon.svg"
						}
					/>
				);
			}
			//Decide if a button is necessary for this step
			let buttonText = "Continue";
			if (step === "signUpFail") {
				buttonText = "Try Again";
			} else if (step === "signUpSuccess" || step === "duplicateEmail") {
				buttonText = "Okay";
			}
			let continueButton = (
				<div className={styles.continue} onClick={this.onContinue}>
					{buttonText}
				</div>
			);
			if (step === "signingUp") {
				continueButton = <div className={styles.continueHidden} />;
			}

			if (isOpen) {
				return (
					<OfficeModal
						onClose={this.onClose}
						closeOnEsc={true}
						portalContainer={null}
						level="overBar"
						modalClass={styles.main}
					>
						<div className={styles.container}>
							<div className={styles.aboveButton}>
								<div className={styles.title}>
									{aboveTitle}
									{Copy[step]}
								</div>
								{contents}
								{belowContents}
							</div>
							{continueButton}
						</div>
					</OfficeModal>
				);
			} else {
				return null;
			}
		},
	})
);
